
import DataMapper from '../DataMapper'
import AttendentRM from '../../responsemodel/ReportRM/AttendentRM'
import Attendents from '../../../models/ReportModels/Attendents'

export default class AttendentDataMapper extends DataMapper<AttendentRM, Attendents> {
    map = (rm: AttendentRM) => new Attendents(rm._id, rm.name, rm.mobile, rm.dob)
}
